import {
  Swiper,
  Navigation,
  Pagination,
  Controller,
  Autoplay
} from 'swiper';

Swiper.use([Navigation, Pagination, Controller, Autoplay]);

new Swiper('.swiper-carousel', {
  speed: 600,
  spaceBetween: 0,
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
});

new Swiper('.opinion-carousel', {
  speed: 600,
  spaceBetween: 15,
  slidesPerView: 1,
  loop: false,
  pagination: {
    el: '.opinion-pagination',
    type: 'bullets',
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    }
  }
});

new Swiper('.post-carousel', {
  speed: 600,
  spaceBetween: 15,
  slidesPerView: 1,
  loop: false,
  pagination: {
    el: '.post-pagination',
    type: 'bullets',
    clickable: true
  },
  breakpoints: {
    540: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4,
    }
  }
});

new Swiper('.double-post-slider', {
  speed: 600,
  spaceBetween: 30,
  slidesPerView: 1,
  pagination: {
    el: '.double-post-pagination',
    type: 'bullets',
    clickable: true
  }
});

const bookCoverSlider = new Swiper('.book-cover-slider', {
  speed: 500,
  spaceBetween: 15,
  slidesPerView: 1,
  breakpoints: {
    540: {
      slidesPerView: 2,
    },
  }
});

const bookSlider = new Swiper('.book-slider', {
  speed: 600,
  spaceBetween: 15,
  slidesPerView: 1,
  pagination: {
    el: '.book-slider-pagination',
    type: 'bullets',
    clickable: true
  },
  breakpoints: {
    540: {
      slidesPerView: 2,
    },
  }
});

if (bookSlider.controller && bookCoverSlider.controller) {
  bookSlider.controller.control = bookCoverSlider;
  bookCoverSlider.controller.control = bookSlider;
}

const timelineSlider = new Swiper('.timeline-slider', {
  speed: 600,
  spaceBetween: 15,
  slidesPerView: 2,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  }
});

const eventsSlider = new Swiper('.events-slider', {
  speed: 600,
  spaceBetween: 15,
  slidesPerView: 2,
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
  }
});

if (eventsSlider.controller && timelineSlider.controller) {
  eventsSlider.controller.control = timelineSlider;
  timelineSlider.controller.control = eventsSlider;
}


const megaSliderNav = document.querySelectorAll('.mega-slider-thumb');
if (megaSliderNav) {
  const megaSlider = new Swiper('.mega-slider', {
    speed: 1000,
    spaceBetween: 30,
    slidesPerView: 1,
    loop: false,
    centeredSlides: true,
    autoplay:{
      delay: 5000,
    },
    on: {
      init: (swiper) => activateSlideNav(swiper)
    },
    pagination: {
      el: '.mega-slider-pagination',
      clickable: true
    }
  });

  megaSlider.on('slideChange', (swiper) => activateSlideNav(swiper));

  Array.from(megaSliderNav).forEach(nav => {
    if (nav.dataset.sliderNav) {
      nav.addEventListener('click', () => {
        megaSlider.slideTo(nav.dataset.sliderNav)
      })
    }
  })

}

function activateSlideNav(instance) {

  Array.from(megaSliderNav).forEach(nav => {
    nav.classList.remove('current');
  });
  const currentNav = document.querySelector('[data-slider-nav="' + instance.realIndex + '"');
  if (currentNav) {
    currentNav.classList.add('current');
  }

}
